// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compliace-main-header {
  margin-top: 2rem;
  color: #126fdb;
  font-size: 2rem;
  margin-bottom: 2rem;
  text-decoration: underline;
  text-decoration-color: lightblue;
}

.compliace-second-header {
  margin-top: 0.3rem;
  font-size: 1.2rem;
}

.complianceParagraph {
  margin-top: 2.3rem;
  text-size-adjust: auto;
}
.compliace-article {
  max-width: 35rem;
  margin-left: 1rem;
}

.compliance-flex-center {
  margin: 0 auto;
}

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
  sm, small: 600px
  md, medium: 900px
  lg, large: 1200px
  xl, extra-large: 1536px */

  @media only screen and (min-width: 300px) {
    .compliace-main-header {
      font-size: 1.1rem;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (min-width: 500px) {
    .compliace-main-header {
      font-size: 1.3rem;
    }
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .compliace-main-header {
      font-size: 1.4rem;
    }
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .compliace-main-header {
      font-size: 1.6rem;
    }
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .compliace-main-header {
      font-size: 1.8rem;
    }
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .compliace-main-header {
      font-size: 2rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Compliance/Compliance.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE;;;;2BAIyB;;EAEzB;IACE;MACE,iBAAiB;IACnB;EACF;EACA,iDAAiD;EACjD;IACE;MACE,iBAAiB;IACnB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,iBAAiB;IACnB;EACF;EACA,qDAAqD;EACrD;IACE;MACE,iBAAiB;IACnB;EACF;EACA,mDAAmD;EACnD;IACE;MACE,iBAAiB;IACnB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,eAAe;IACjB;EACF;AACF","sourcesContent":[".compliace-main-header {\n  margin-top: 2rem;\n  color: #126fdb;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  text-decoration: underline;\n  text-decoration-color: lightblue;\n}\n\n.compliace-second-header {\n  margin-top: 0.3rem;\n  font-size: 1.2rem;\n}\n\n.complianceParagraph {\n  margin-top: 2.3rem;\n  text-size-adjust: auto;\n}\n.compliace-article {\n  max-width: 35rem;\n  margin-left: 1rem;\n}\n\n.compliance-flex-center {\n  margin: 0 auto;\n}\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n  sm, small: 600px\n  md, medium: 900px\n  lg, large: 1200px\n  xl, extra-large: 1536px */\n\n  @media only screen and (min-width: 300px) {\n    .compliace-main-header {\n      font-size: 1.1rem;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (min-width: 500px) {\n    .compliace-main-header {\n      font-size: 1.3rem;\n    }\n  }\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    .compliace-main-header {\n      font-size: 1.4rem;\n    }\n  }\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    .compliace-main-header {\n      font-size: 1.6rem;\n    }\n  }\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    .compliace-main-header {\n      font-size: 1.8rem;\n    }\n  }\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    .compliace-main-header {\n      font-size: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
